import React from 'react';

export const ListInitialVariablesContext = React.createContext(null);
